import React from 'react';
import { resolveForestAddress } from '../../../utils/forestAddress';
import { handbookById, resolveSubjectRefId, HANDBOOK_SUBJECTS_ID } from './pickerHooks';

const DetailsSection = ({ handbooks, displayData, localFormData, setLocalFormData, openPicker, clearTableData }) => {
  const address = resolveForestAddress(displayData, handbooks);
  return (
    <div className="group-section">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <h4>Сведения</h4>
        <button 
          type="button" 
          onClick={() => clearTableData('details')}
          style={{
            background: '#6c757d',
            color: 'white',
            border: 'none',
            padding: '5px 10px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '12px'
          }}
        >
          Очистить
        </button>
      </div>
      <div>
        <table className="table">
          <thead>
            <tr>
              <th>Субъект РФ <span className="required">*</span></th>
              <th>Организация, проводившая работу <span className="required">*</span></th>
              <th>Лесничество <span className="required">*</span></th>
              <th>Уч. лесничество <span className="required">*</span></th>
              <th>Урочище {address.isUrcRequired && <span className="required">*</span>}</th>
              <th>Квартал <span className="required">*</span></th>
              <th>Кадастровый номер участка</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="coordinate-cell">
                <div 
                  className="reference-cell"
                  onClick={() => openPicker('srf', 12)}
                  style={{ 
                    minHeight: 60, 
                    height: 'auto',
                    cursor: 'pointer',
                    background: 'transparent'
                  }}
                >
                  <textarea
                    name="srf"
                    id="form1-srf"
                    readOnly
                    value={(() => {
                      const handbook = handbookById(handbooks, HANDBOOK_SUBJECTS_ID);
                      const srfId = resolveSubjectRefId(displayData.srf, handbooks);
                      if (handbook && handbook.references && srfId) {
                        const selectedOption = handbook.references.find(
                          (r) => String(r.id) === srfId
                        );
                        if (selectedOption) return selectedOption.name;
                      }
                      if (displayData.srf && typeof displayData.srf === 'object') {
                        return displayData.srf.name || '';
                      }
                      if (typeof displayData.srf === 'string' && !/^\d+$/.test(displayData.srf.trim())) {
                        return displayData.srf;
                      }
                      return '';
                    })()}
                    placeholder="☰"
                    style={{
                      border: 'none',
                      outline: 'none',
                      resize: 'none',
                      background: 'none',
                      borderRadius: '0',
                      minHeight: 60,
                      height: 'auto',
                      textAlign: 'center',
                      width: '100%',
                      overflow: 'hidden',
                      padding: '6px 0',
                      boxSizing: 'border-box',
                      cursor: 'pointer',
                    }}
                    className={`form-control ${!displayData.srf ? 'required-field' : ''} coordinate-field`}
                  />
                </div>
              </td>
              <td className="coordinate-cell">
                <div 
                  className="reference-cell"
                  onClick={() => openPicker('filial')}
                  style={{ 
                    minHeight: 60, 
                    height: 'auto',
                    cursor: 'pointer',
                    background: 'transparent'
                  }}
                >
                  <textarea
                    name="filial"
                    id="form1-filial"
                    readOnly
                    value={displayData.filial || ''}
                    placeholder="☰"
                    style={{
                      border: 'none',
                      outline: 'none',
                      resize: 'none',
                      background: 'none',
                      borderRadius: '0',
                      minHeight: 60,
                      height: 'auto',
                      textAlign: 'center',
                      width: '100%',
                      overflow: 'hidden',
                      padding: '6px 0',
                      boxSizing: 'border-box',
                      cursor: 'pointer',
                    }}
                    className={`form-control ${!displayData.filial ? 'required-field' : ''} coordinate-field`}
                  />
                </div>
              </td>
              <td className="coordinate-cell">
                <div 
                  className="reference-cell"
                  onClick={() => openPicker('lvo')}
                  style={{ 
                    minHeight: 60, 
                    height: 'auto',
                    cursor: 'pointer',
                    background: 'transparent'
                  }}
                >
                  <textarea
                    name="lvo"
                    id="form1-lvo"
                    readOnly
                    value={displayData.lvo || ''}
                    placeholder="☰"
                    style={{
                      border: 'none',
                      outline: 'none',
                      resize: 'none',
                      background: 'none',
                      borderRadius: '0',
                      minHeight: 60,
                      height: 'auto',
                      textAlign: 'center',
                      width: '100%',
                      overflow: 'hidden',
                      padding: '6px 0',
                      boxSizing: 'border-box',
                      cursor: 'pointer',
                    }}
                    className={`form-control ${!displayData.lvo ? 'required-field' : ''} coordinate-field`}
                  />
                </div>
              </td>
              <td className="coordinate-cell">
                <div 
                  className="reference-cell"
                  onClick={() => openPicker('ulvo')}
                  style={{ 
                    minHeight: 60, 
                    height: 'auto',
                    cursor: 'pointer',
                    background: 'transparent'
                  }}
                >
                  <textarea
                    name="ulvo"
                    id="form1-ulvo"
                    readOnly
                    value={displayData.ulvo || ''}
                    placeholder="☰"
                    style={{
                      border: 'none',
                      outline: 'none',
                      resize: 'none',
                      background: 'none',
                      borderRadius: '0',
                      minHeight: 60,
                      height: 'auto',
                      textAlign: 'center',
                      width: '100%',
                      overflow: 'hidden',
                      padding: '6px 0',
                      boxSizing: 'border-box',
                      cursor: 'pointer',
                    }}
                    className={`form-control coordinate-field ${!address.ulvo ? 'required-field' : ''}`}
                    aria-required="true"
                  />
                </div>
              </td>
              <td className="coordinate-cell">
                <div 
                  className="reference-cell"
                  onClick={() => openPicker('urc')}
                  style={{ 
                    minHeight: 60, 
                    height: 'auto',
                    cursor: 'pointer',
                    background: 'transparent'
                  }}
                >
                  <textarea
                    name="urc"
                    id="form1-urc"
                    readOnly
                    disabled={!address.isUrcRequired}
                    value={displayData.urc || ''}
                    placeholder="☰"
                    style={{
                      border: 'none',
                      outline: 'none',
                      resize: 'none',
                      background: 'none',
                      borderRadius: '0',
                      minHeight: 60,
                      height: 'auto',
                      textAlign: 'center',
                      width: '100%',
                      overflow: 'hidden',
                      padding: '6px 0',
                      boxSizing: 'border-box',
                      cursor: 'pointer',
                    }}
                    className={`form-control coordinate-field ${address.isUrcRequired && !address.urc ? 'required-field' : ''}`}
                    aria-required={address.isUrcRequired}
                  />
                </div>
              </td>
              <td className="coordinate-cell">
                <div style={{ 
                  minHeight: 60, 
                  height: 'auto'
                }}>
                  <textarea
                    name="kv"
                    id="form1-kv"
                    value={displayData.kv || ''}
                    onChange={(e) => {
                      const newData = { ...localFormData, kv: e.target.value };
                      setLocalFormData(newData);
                      if (setLocalFormData) {
                        setLocalFormData(prev => ({ ...prev, kv: e.target.value }));
                      }
                    }}
                    className={`form-control ${!displayData.kv ? 'required-field' : ''} coordinate-field`}
                    style={{
                      border: 'none',
                      outline: 'none',
                      resize: 'none',
                      background: 'none',
                      borderRadius: '0',
                      minHeight: 60,
                      height: 'auto',
                      textAlign: 'center',
                      width: '100%',
                      overflow: 'hidden',
                      padding: '6px 0',
                      boxSizing: 'border-box'
                    }}
                    rows={100}
                  />
                </div>
              </td>
              <td className="coordinate-cell">
                <div style={{ 
                  minHeight: 60, 
                  height: 'auto'
                }}>
                  <textarea
                    name="kadnomer"
                    id="form1-kadnomer"
                    value={displayData.kadnomer || ''}
                    onChange={(e) => {
                      // Формат не навязываем: шаблон показывается плейсхолдером,
                      // пока поле пустое, но ввод не ограничивается — кадастровый
                      // номер бывает и с шестизначным кварталом.
                      setLocalFormData(prev => ({ ...prev, kadnomer: e.target.value }));
                    }}
                    placeholder="11:11:1111111:1111"
                    className="form-control coordinate-field"
                    style={{
                      border: 'none',
                      outline: 'none',
                      resize: 'none',
                      background: 'none',
                      borderRadius: '0',
                      minHeight: 60,
                      height: 'auto',
                      textAlign: 'center',
                      width: '100%',
                      overflow: 'hidden',
                      padding: '6px 0',
                      boxSizing: 'border-box'
                    }}
                    rows={100}
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DetailsSection;

